import { inject, InjectionToken } from '@angular/core';
import { Store } from '@ngrx/store';
import { selectors } from '@twaice-fe/frontend/shared/store';
import { distinctUntilChanged, map, Observable } from 'rxjs';

const { systemSelectors } = selectors;

/** For pages spanning several systems, where no single selected system's storage timezone applies. */
export const STORAGE_TIMEZONE_OVERRIDE = new InjectionToken<Observable<string>>('STORAGE_TIMEZONE_OVERRIDE');

export function injectStorageTimezone(): Observable<string | null> {
  const override$ = inject(STORAGE_TIMEZONE_OVERRIDE, { optional: true });
  const storageTimezone$ =
    override$ ??
    inject(Store)
      .select(systemSelectors.getSelected)
      .pipe(map((system) => system?.bessMetadata?.storageTimezone ?? null));

  return storageTimezone$.pipe(distinctUntilChanged());
}
